import Typography from "../../Typography/Typography";
import styles from "./ButtonFotter.module.scss";

/**
 * dock="viewport" — fixed to the browser bottom (default).
 * dock="panel" — bottom of a positioned column (IdP full-page login).
 */
const ButtonFotter = ({
	children,
	onClick,
	disabled = false,
	dock = "viewport",
}) => {
	const dockClass =
		dock === "panel" ? styles.buttonFooterPanel : styles.buttonFooter;

	return (
		<button
			className={dockClass}
			onClick={onClick}
			disabled={disabled}
		>
			<Typography color="white" variant="h3">
				{children}
			</Typography>
		</button>
	);
};

export default ButtonFotter;
